theme.headerSearch = (function () {
  function searchOverlay(e) {
    const input = e.querySelector('input[type="search"]');

    const drawerAction = (trigger, closeTrigger, wrapper) => {
      const offcanvasSearchTriggers = document.querySelectorAll(trigger);
      const offcanvasSidebarSearch = document.querySelector(wrapper);
      const offcanvasSearchClose = document.getElementById(closeTrigger);
      const resetBtn = document.getElementById("Search-Modal-Reset");

      if (!offcanvasSidebarSearch) return;

      const openSearch = (singleTrigger) => {
        offcanvasSidebarSearch.classList.add("active");
        document.body.classList.add("added__overlay_search");

        // Focus input immediately for fast keyboard appearance on mobile
        if (input) {
          setTimeout(() => {
            input.focus();
            if (typeof trapFocus === "function") {
              trapFocus(offcanvasSidebarSearch, input);
            }
          }, 50);
        }

        // Render recent searches if empty
        const predictiveEl = offcanvasSidebarSearch.querySelector("predictive-search");
        if (predictiveEl && typeof predictiveEl.renderRecentSearches === "function") {
          predictiveEl.renderRecentSearches();
        }

        // Push state for Android WebView Back navigation
        if (!window.history.state?.searchModalOpen) {
          window.history.pushState({ searchModalOpen: true }, "", window.location.href);
        }
      };

      const closeSearch = (singleTrigger) => {
        offcanvasSidebarSearch.classList.remove("active");
        document.body.classList.remove("added__overlay_search");
        if (input) input.blur();

        if (singleTrigger && typeof removeTrapFocus === "function") {
          removeTrapFocus(singleTrigger);
        }

        if (window.history.state?.searchModalOpen) {
          window.history.back();
        }
      };

      offcanvasSearchTriggers.forEach((singleTrigger) => {
        if (!singleTrigger) return;

        singleTrigger.addEventListener("click", (event) => {
          event.preventDefault();
          openSearch(singleTrigger);
        });

        offcanvasSidebarSearch.addEventListener("keyup", (evt) => {
          if (evt.code === "Escape" || evt.key === "Escape") {
            closeSearch(singleTrigger);
          }
        });

        if (offcanvasSearchClose) {
          offcanvasSearchClose.addEventListener("click", (event) => {
            event.preventDefault();
            closeSearch(singleTrigger);
          });
        }
      });

      // Clear button handling
      if (resetBtn && input) {
        resetBtn.addEventListener("click", (event) => {
          event.preventDefault();
          input.value = "";
          input.focus();
          resetBtn.classList.add("hidden");
          const predictiveEl = offcanvasSidebarSearch.querySelector("predictive-search");
          if (predictiveEl) {
            predictiveEl.close(true);
            predictiveEl.renderRecentSearches();
          }
        });
      }

      // Close when clicking outside on desktop
      document.addEventListener("click", function (event) {
        const eventTarget = event.target;
        if (
          offcanvasSidebarSearch.classList.contains("active") &&
          !eventTarget.closest("#predictive__search_overlay") &&
          !eventTarget.closest(".header__actions_btn--search") &&
          !eventTarget.closest(".mobile__navigate--item")
        ) {
          offcanvasSidebarSearch.classList.remove("active");
          document.body.classList.remove("added__overlay_search");
        }
      });

      // Unlock scroll immediately when clicking any result link
      offcanvasSidebarSearch.addEventListener("click", (event) => {
        if (event.target.closest("a")) {
          offcanvasSidebarSearch.classList.remove("active");
          document.body.classList.remove("added__overlay_search");
        }
      });

      // Handle Android WebView / Browser Back
      window.addEventListener("popstate", (event) => {
        if (offcanvasSidebarSearch.classList.contains("active")) {
          offcanvasSidebarSearch.classList.remove("active");
          document.body.classList.remove("added__overlay_search");
        }
      });

      // Restore clean body state on bfcache page restore
      window.addEventListener("pageshow", () => {
        document.body.classList.remove("added__overlay_search");
      });
    };

    drawerAction(
      ".header__actions_btn--search",
      "search__close_btn",
      "#predictive__search_overlay"
    );
  }

  return searchOverlay;
})();
